import * as i0 from "@angular/core";
export class LocalStorageService {
    constructor() { }
    getCurrentUser() {
        return JSON.parse(localStorage.getItem('userLoginSession'));
    }
    setCurrentUser(userData) {
        localStorage.setItem('userLoginSession', JSON.stringify(userData));
    }
    getCustomerLabels() {
        return JSON.parse(sessionStorage.getItem('customerLabels')) || [];
    }
    setCustomerLabels(labels) {
        sessionStorage.setItem('customerLabels', JSON.stringify(labels));
    }
}
LocalStorageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LocalStorageService_Factory() { return new LocalStorageService(); }, token: LocalStorageService, providedIn: "root" });
